import { render, staticRenderFns } from "./WeChatReturnPage.vue?vue&type=template&id=a33741d2&scoped=true&"
import script from "./WeChatReturnPage.vue?vue&type=script&lang=js&"
export * from "./WeChatReturnPage.vue?vue&type=script&lang=js&"
import style0 from "@/components/auth.css?vue&type=style&index=0&lang=css&"
import style1 from "./WeChatReturnPage.vue?vue&type=style&index=1&id=a33741d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a33741d2",
  null
  
)

export default component.exports